<template>
  <div v-if="!item.Concluido">
    <span
      v-for="(action, actionKey) in actions"
      v-if="checkPermission(action)"
      :key="actionKey"
      class="action-icon"
      data-toggle="tooltip"
      data-placement="top"
      :title="action.title"
      @click="action.onclick(item)"
    >
      <i :class="action.class" class="fa-fw" />
    </span>
  </div>
  <div v-else>
    <span
      v-for="(action, actionKey) in filteredActions"
      v-if="checkPermission(action)"
      :key="actionKey"
      class="action-icon"
      data-toggle="tooltip"
      data-placement="top"
      :title="action.title"
      @click="action.onclick(item)"
    >
      <i :class="action.class" class="fa-fw" />
    </span>
  </div>
</template>

<script>
import $ from 'jquery'
import 'bootstrap'
import { find } from 'lodash'
export default {
  name: 'ActionItem',
  props: ['actions', 'item'],
  mounted() {
    $(this.$el)
      .find('[data-toggle="tooltip"]')
      .tooltip()
  },
  computed: {
    filteredActions() {
      return [find(this.actions, { name: 'details' })]
    }
  },
  methods: {
    checkPermission({ component, claim }) {
      if (!component || !claim) return true
      return this.$root.$checkPermission(component, claim)
    }
  }
}
</script>
